import { Conexion } from "../../../Config/Coneccion";

export default interface Proveedor {
    codigo: string
    nombre: string
    telefono: string
    correo: string
    contacto: string
    direccion: string
    pais: string
    ciudad: string
    estado: string
    estatus: number
}
export var ProveedorNull: Proveedor = {
    codigo: "",
    nombre: "",
    telefono: "",
    correo: "",
    contacto: "",
    direccion: "",
    pais: "",
    ciudad: "",
    estado: "",
    estatus: 1
}
class ProveedorConexion extends Conexion {
    clase = 'Proveedor';
    persistencia = 1000;
}
var coProv: ProveedorConexion;
export function conProveedor() {
    if (coProv === undefined) coProv = new ProveedorConexion();
    return coProv;
}